import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  QuoteSearchRequest,
  QuoteSearchResult
} from '@app/models/quote-search.model';
import {
  IBorrowerInfo,
  IRecentActivityResponse
} from '@app/models/unity-direct.model';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Constants } from 'src/app/constants';

import { UnityDirectStateService } from './unity-direct-state.service';

@Injectable({ providedIn: 'root' })
export class UnityDirectMegaMenuService {
  quoteSearchResultStore: QuoteSearchResult[] = [];
  searchFormStore: Partial<QuoteSearchRequest>;

  constructor(
    private http: HttpClient,
    private udStateService: UnityDirectStateService
  ) {}

  /**
   * Get Recent Activity data for Quotes dropdown
   * @returns IRecentActivityResponse data
   */
  public getRecentActivity(): Observable<IRecentActivityResponse[]> {
    const userInfo = this.udStateService.userInfo;
    return this.http.get<IRecentActivityResponse[]>(
      `${Constants.appConfiguration.apiRoot}/User/${userInfo.AccountId}`
    );
  }

  /**
   * Gets search data given params. Accepts a partial of {QuoteSearchRequest}. Stores request to retain data
   * @param params {Partial<QuoteSearchRequest>}
   * @returns {Observable<QuoteSearchResult[]>}
   */
  public getSearchData(
    params: Partial<QuoteSearchRequest>
  ): Observable<QuoteSearchResult[]> {
    this.searchFormStore = { ...params };
    const userInfo = this.udStateService.userInfo;
    return this.http
      .get<
        QuoteSearchResult[]
      >(`${Constants.appConfiguration.apiRoot}/Search/BillingSearch/${userInfo.AccountId}`, { params: params })
      .pipe(
        tap(
          (searchResult: QuoteSearchResult[]) =>
            (this.quoteSearchResultStore = searchResult)
        )
      );
  }

  // Get Borrower search results
  public getBorrowerData(params: {
    [key: string]: string;
  }): Observable<IBorrowerInfo[]> {
    const userInfo = this.udStateService.userInfo;
    return this.http.get<IBorrowerInfo[]>(
      `${Constants.appConfiguration.apiRoot}/Search/BorrowerSearch/${userInfo.AccountId}`,
      { params: params }
    );
  }

  //  Get Portal header code response
  getHeaderForApp(): Observable<string> {
    return this.http.get(`${Constants.appConfiguration.headerURL}`, {
      responseType: 'text'
    });
  }
}
